import React from 'react';
import ScrollReveal from '../ui/ScrollReveal';
import { Award, Users, Check } from 'lucide-react';
const GuideSection = () => {
  return <section className="py-24 pb-16 px-6 md:px-12 lg:px-24 bg-white relative overflow-hidden" data-id="element-258">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-[#EDE8F5]/10 to-white" data-id="element-259"></div>
      <div className="max-w-7xl mx-auto relative" data-id="element-260">
        <ScrollReveal data-id="element-261">
          <div className="flex flex-col items-center mb-16" data-id="element-262">
            <span className="inline-block px-4 py-1 bg-[#3D52A0]/10 rounded-full text-sm font-medium text-[#3D52A0] mb-6" data-id="element-263">
              The Solution
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#3D52A0] mb-6 text-center" data-id="element-264">
              Church Communications made simple. Copywriting made automatic.
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#3D52A0] to-[#7091E6] rounded-full mb-6" data-id="element-265"></div>
            <p className="text-lg md:text-xl text-gray-700 max-w-3xl text-center" data-id="element-266">
              Shepherd Flow AI creates full communication campaigns for your
              events—so you can focus on people, not copywriting.
            </p>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-267">
          <ScrollReveal delay={200} className="order-2 md:order-1" data-id="element-268">
            <div className="space-y-8" data-id="element-269">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-medium" data-id="element-270">
                Here's what you get:
              </p>
              <div className="space-y-4" data-id="element-271">
                <div className="flex items-start gap-3" data-id="element-272">
                  <div className="bg-[#EDE8F5] p-1 rounded-full mt-1" data-id="element-273">
                    <Check className="text-[#3D52A0] h-5 w-5" data-id="element-274" />
                  </div>
                  <p className="text-gray-700" data-id="element-275">
                    <span className="font-semibold" data-id="element-276">Invite Campaigns</span> —
                    texts, emails, and social posts that drive attendance.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-277">
                  <div className="bg-[#EDE8F5] p-1 rounded-full mt-1" data-id="element-278">
                    <Check className="text-[#3D52A0] h-5 w-5" data-id="element-279" />
                  </div>
                  <p className="text-gray-700" data-id="element-280">
                    <span className="font-semibold" data-id="element-281">Reminder Campaigns</span> —
                    keep guests engaged with timely nudges.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-282">
                  <div className="bg-[#EDE8F5] p-1 rounded-full mt-1" data-id="element-283">
                    <Check className="text-[#3D52A0] h-5 w-5" data-id="element-284" />
                  </div>
                  <p className="text-gray-700" data-id="element-285">
                    <span className="font-semibold" data-id="element-286">Follow-Up Campaigns</span> —
                    personal thank-yous, next steps, and invitations to return.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-287">
                  <div className="bg-[#EDE8F5] p-1 rounded-full mt-1" data-id="element-288">
                    <Check className="text-[#3D52A0] h-5 w-5" data-id="element-289" />
                  </div>
                  <p className="text-gray-700" data-id="element-290">
                    <span className="font-semibold" data-id="element-291">
                      Multi-channel delivery
                    </span>{' '}
                    — text, email, social, postcard, and voicemail scripts.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-292">
                  <div className="bg-[#EDE8F5] p-1 rounded-full mt-1" data-id="element-293">
                    <Check className="text-[#3D52A0] h-5 w-5" data-id="element-294" />
                  </div>
                  <p className="text-gray-700" data-id="element-295">
                    <span className="font-semibold" data-id="element-296">
                      Personalized messaging
                    </span>{' '}
                    — written in your church's tone, color, and style.
                  </p>
                </div>
              </div>
              <div className="bg-gradient-to-r from-[#3D52A0]/10 to-[#7091E6]/10 p-6 rounded-lg border-l-4 border-[#3D52A0] mb-6 shadow-inner" data-id="element-297">
                <p className="italic text-gray-700 text-lg relative" data-id="element-298">
                  <span className="absolute -top-4 -left-2 text-4xl text-[#3D52A0]/20 font-serif" data-id="element-299">
                    "
                  </span>
                  Because the event is the moment—but the follow-up is the
                  movement.
                  <span className="absolute -bottom-4 -right-2 text-4xl text-[#3D52A0]/20 font-serif" data-id="element-300">
                    "
                  </span>
                </p>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={400} className="order-1 md:order-2" data-id="element-301">
            <div className="relative" data-id="element-302">
              {/* Decorative elements */}
              <div className="absolute -top-8 -left-8 w-24 h-24 bg-[#EDE8F5] rounded-full opacity-50" data-id="element-303"></div>
              <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-[#7091E6] rounded-full opacity-20" data-id="element-304"></div>
              {/* Main image with angled background */}
              <div className="relative z-10" data-id="element-305">
                <div className="absolute inset-0 bg-[#7091E6] rounded-lg transform rotate-3 shadow-xl" data-id="element-306"></div>
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nXQp24z1Lu7VboEZqtNrgw/2025-10-09_14-35-55.png" alt="Shepherd Flow AI campaign strategy dashboard showing follow-up communications" className="relative rounded-lg shadow-lg w-full h-auto object-cover" data-id="element-307" />
                {/* Badges */}
                <div className="absolute top-4 -left-4 bg-white p-3 rounded-full shadow-lg" data-id="element-308">
                  <Award className="text-[#3D52A0] h-8 w-8" data-id="element-309" />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-white p-3 rounded-lg shadow-lg" data-id="element-310">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h9NB9E8yxNHJSdxggKx4Ly/2025-10-09_14-33-18.png" alt="Shepherd Flow AI event campaign form" className="h-16 w-auto" data-id="element-311" />
                </div>
                {/* Feature badges */}
                <div className="absolute -bottom-6 left-8 bg-white py-2 px-4 rounded-full shadow-lg flex items-center gap-2" data-id="element-312">
                  <Check className="text-green-500 h-4 w-4" data-id="element-313" />
                  <span className="text-sm font-medium" data-id="element-314">Church-Focused AI</span>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
};
export default GuideSection;